import { ComponentRef, EmbeddedViewRef, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';

import { ComponentPortal, TemplatePortal } from '../core/core.module';
import { NotificationStyle } from './notification-config';

export abstract class NotificationHostBase {
  public abstract hostClick: EventEmitter<any>;
  public abstract topButtonClick: EventEmitter<void>;
  public abstract afterClosed: Observable<any>;
  public abstract beforeClose: Observable<any>;
  public abstract setStyle(style: NotificationStyle): void;
  public abstract close(): void;

  public abstract attachTemplatePortal(portal: TemplatePortal): EmbeddedViewRef<any>;
  public abstract attachComponentPortal<T>(
    portal: ComponentPortal<T>,
    index?: number,
  ): ComponentRef<T>;
}
